const start = {
  slug: 'start',
  title: 'Hoe moet Zaventem er voor jou uitzien?',
  body:
    'Nadat we gepeild hebben naar jouw gedrag, willen we graag weten hoe je de mobiliteitsmix in Zaventem ziet. Waar moet Zaventem meer op inzetten? Wat is een goede mix voor de mobiliteit in onze gemeente?<br/><br/>Voeg één voor één de manieren toe om je te verplaatsen in Zaventem, tot je de ideale mix hebt.',
  controls: false,
  backgroundImage: 'zaventem_cover.jpg',
  cameraPosition: [0, 0, 0],
  cameraRotation: [0, 0, 0],
  layers: ['base'],
};

const auto = {
  slug: 'auto',
  title: 'Wat is de rol van de auto in Zaventem?',
  body:
    'Op dit moment verplaatst 61% zich in Zaventem met de auto voor verplaatsingen tussen woonplaats en werk of school. Hoeveel % zou dat in de toekomst moeten zijn? Via de knoppen kan je meer of minder auto’s in het straatbeeld plaatsen.',
  controls: true,
  controlsAuto: true,
  cameraPosition: [275.18634910692253, 36.77878243466174, 360.7666420282573],
  cameraRotation: [-0.22490104125078197, 0.15154768409891375, 0.034523471732248574],
  layers: ['base'],
  metrics: true,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const fiets = {
  slug: 'fiets',
  title: 'Plaats voor fietsers?',
  body:
    'Een alternatief voor de wagen is de fiets. Wat is voor jou een goede balans tussen auto’s en fietsers? Via de knoppen kan je meer of minder fietsen in het straatbeeld plaatsen.',
  controls: true,
  controlsAuto: true,
  controlsFiets: true,
  cameraPosition: [257.5750663894187, 17.17536911642221, 322.1573729209968],
  cameraRotation: [-0.1396847000392789, 0.06132972034280715, 0.00861736206203165],
  layers: ['base'],
  metrics: true,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const voetganger = {
  slug: 'voetganger',
  title: 'Wat kan er te voet?',
  body: 'Ook te voet kunnen er heel wat verplaatsingen gebeuren. Voeg ook voetgangers toe aan je mix.',
  controls: true,
  controlsAuto: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [179.04825358701407, 13.584210065870174, 303.8430327164899],
  cameraRotation: [-0.2419138175545134, -0.6626926059925935, -0.15065817737167725],
  layers: ['base'],
  metrics: true,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const ov = {
  slug: 'ov',
  title: 'Bussen en treinen',
  body:
    'Er zijn verschillende buslijnen die Zaventem doorkruisen. Zie je het zitten om voor bepaalde verplaatsingen de bus of de trein te nemen? Hoeveel van de verplaatsingen kunnen er volgens jou met de bus gebeuren?',
  controls: true,
  controlsAuto: true,
  controlsFiets: true,
  controlsVoetganger: true,
  controlsOV: true,
  cameraPosition: [259.6026909345831, 17.89190013753407, 328.81920392908523],
  cameraRotation: [-0.14238980641212357, 0.037361848242808644, 0.005354896828021077],
  layers: ['base'],
  metrics: true,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const deelauto = {
  slug: 'deelauto',
  title: 'Kunnen we auto’s delen?',
  body:
    'Verschillende onderzoeken hebben aangetoond dat één deelwagen 8 tot 12 voertuigen kan vervangen. Zou jij het zien zitten om een auto weg te doen en te vervangen door een deelvoertuig?<br/><br/>Test hier wat de impact is van het aandeel deelvoertuigen op de noodzaak aan parkeerplaatsen en op het straatbeeld in het algemeen.',
  controls: true,
  controlsAuto: true,
  controlsFiets: true,
  controlsVoetganger: true,
  controlsOV: true,
  controlsDeelauto: true,
  cameraPosition: [289.43492717652134, 24.603210281083328, 326.5493638516077],
  cameraRotation: [-0.2754514318376997, 0.00692804248723886, 0.001958096374579882],
  layers: ['base'],
  metrics: true,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const sandbox = {
  slug: 'sandbox',
  title: 'Jouw ideale mix!',
  body:
    'Heb je nu je ideale mix van vervoersmiddelen voor Zaventem gemaakt? Kijk het nog even na en pas eventueel nog een beetje aan en geef je mix dan door.',
  controls: true,
  controlsAuto: true,
  controlsFiets: true,
  controlsVoetganger: true,
  controlsOV: true,
  controlsDeelauto: true,
  cameraPosition: [250.7764129608417, 60.91237544490415, 333.17570962915363],
  cameraRotation: [-0.7441052084988765, 0, 0],
  layers: ['base'],
  metrics: true,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const share = {
  slug: 'share',
  title: 'Bedankt!',
  body:
    'We hebben jouw ideale mix goed ontvangen. Deel jouw mix en vraag zoveel mogelijk inwoners om hun mix te delen.<br/><br/>Hoe pakken we de mobiliteit in Zaventem nu concreet aan?<br/><strong><a href="https://zaventemaanzet.be/overzicht">Geef hier je ideeën</a></strong> voor mobiliteitsverbeteringen in Zaventem!<br/>',
  cameraPosition: [220.23096354608043, 26.487662335356276, 332.16698429635824],
  cameraRotation: [-0.22478551813376968, 0.00006208383559583942, 0.000014195448139600235],
  layers: ['base'],
  socialMedia: true,
  metrics: false,
  goal: 1000000,
  goalText: '1 miljoen verplaatsingen',
};

const sequence = {
  name: 'Zaventem',
  db: 'zaventem',
  scenes: [start, auto, fiets, voetganger, ov, deelauto, sandbox, share],
  layerMap: {},
};

export default sequence;
